import React, {useEffect, useState} from 'react';
import {getOnBoardingData, updateOnBoardingData} from "../services/awsHandler";
import usePrivacy from "../services/usePrivacy";

const OnBoarding = (props) => {
    const { } = props;
    const [onBoardingMembers, setOnBoardingMembers] = useState(null)
    const [newMember, setNewMember] = useState(null);
    const ready = usePrivacy()

    useEffect(() => {
        if(ready) fetchOnBoardingMembers()
    }, [ready]);

    const fetchOnBoardingMembers = async () => {
        const res = await getOnBoardingData()
        setOnBoardingMembers(res)
    }

    const onNewMemberSubmit = async () => {
        if(!newMember.name ||!newMember.mail) window.alert('Please fill all fields')
        if(newMember.mail) {
            const validMail = newMember.mail.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            if (!validMail) window.alert('Invalid mail')
            else {
                const doesExist = onBoardingMembers.some(member => member.mail === newMember.mail)
                if(doesExist) window.alert('Mail already exists for different member')
                else {
                    const newMembers = [...onBoardingMembers, newMember]
                    await updateOnBoardingData(newMembers)
                    window.alert('Member added successfully')
                    setNewMember(null)
                    fetchOnBoardingMembers()
                }
            }
        }
    }

    const onMemberDelete = async (member) => {
        if(!window.confirm('Are you sure you want to delete this member?')) return;
        const newMembers = onBoardingMembers.filter(ob => ob.mail !== member.mail)
        await updateOnBoardingData(newMembers)
        fetchOnBoardingMembers()
    }

    return (
        <div style={{direction: 'ltr', display: 'flex', flexDirection: 'column', gap: '10px', margin: '10px'}}>
            <span style={{fontSize: '24px', fontWeight: 'bold'}}>On-Boarding Members</span>
            <table>
                <tr>
                    <th style={{textAlign: 'start'}}>Name</th>
                    <th style={{textAlign: 'start'}}>Mail</th>
                    <th style={{textAlign: 'start'}}>
                        <button onClick={() => setNewMember({name: '', mail: ''})}>Add</button>
                    </th>
                </tr>
                {onBoardingMembers?.map(member => (
                    <tr key={member.mail}>
                        <td>{member.name}</td>
                        <td>{member.mail}</td>
                        <td><button onClick={() => onMemberDelete(member)}>Delete</button></td>
                    </tr>
                ))}
                {
                    newMember &&
                    <tr>
                        <td><input value={newMember.name} onChange={(e) => setNewMember(prev => ({...prev, name: e.target.value}))} required/></td>
                        <td><input value={newMember.mail} onChange={(e) => setNewMember(prev => ({...prev, mail: e.target.value}))} required/>
                        </td>
                        <td>
                            <button onClick={() => onNewMemberSubmit()}>Save</button></td>
                        <td><button onClick={() => setNewMember(null)}>Cancel</button></td>
                    </tr>
                }
            </table>
        </div>
    );
};

export default OnBoarding;